// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"48f243f1","359":"807c1240","361":"8bd89019","511":"f84fd51b"}[chunkId] + ".chunk.js";
};